export default "__VITE_ASSET__DNj27MQQ__"